import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'programNameARIALabelPipe',
  standalone: true
})
export class ProgramNameARIALabelPipe implements PipeTransform {
  accessibleProgramName = ''
  
  public get ariaLabel(): string {
    return `Click to select the ${this.accessibleProgramName} program`
  }

  transform(programName: string) {
    switch(programName){
      case 'Interest Program':
        this.accessibleProgramName = 'Interest'
        break;
      case 'NY CDPAP':
        this.accessibleProgramName = 'NY C D P A P'
        break;
      default:
        return programName
    }

    return this.ariaLabel
  }
}
